import styles from "./shift-details-stock-inventory.module.scss";
import { allFuelProductsMapper } from "./shift-details-stock-inventory.mapper";
import { allFuelProductsColumn } from "./shift-details-stock-inventory-column";
import { locale } from "localization/en";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import useDataTable from "hooks/useDataTable";
import { sumBy } from "lodash";
import Big from "big.js";

const ShiftDetailsAllFuelProducts = ({ isShiftEndedCompletely, shift }) => {
  const nameToSku = (name) => {
    if (!name) return "";

    return name
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "");
  };

  console.log("shift", shift);

  // const computeTotalAmount = (items) => {
  //   return (
  //     sumBy(
  //       items.map((item) => {
  //         const pumpNumber = Number(String(item.pump).split(" ")[1]);
  //         const pumpDiscount = shift.shiftDiscounts.find(
  //           (discount) =>
  //             discount.product === nameToSku(item.name) && Number(discount.pumpSlot) === pumpNumber
  //         );

  //         let originalTotalAmount;
  //         if ((item.pumpDiscountPerItem ?? 0) !== 0) {
  //           // Liter Input: per-item pump discount stored by POS
  //           const discountValue = item.pumpDiscountPerItem;
  //           const discountedPumpPrice =
  //             getPrice(nameToSku(item.name)) -
  //             (item.vat === 0 ? discountValue / 1.12 : discountValue);
  //           originalTotalAmount = Big(discountedPumpPrice * item.quantity)
  //             .round(2)
  //             .toNumber();
  //         } else if ((item.totalPumpDiscount ?? 0) > 0) {
  //           // Amount Input with stored total pump discount
  //           originalTotalAmount = Big(item.originalTotalAmount)
  //             .minus(item.totalPumpDiscount)
  //             .round(2)
  //             .toNumber();
  //         } else if ((pumpDiscount?.discountPerLiter ?? 0) > 0) {
  //           // Amount Input: pump discount from shift configuration
  //           if (item.discount === "") {
  //             // No promo — netTotalAmount is exact (what cashier entered)
  //             originalTotalAmount = item.netTotalAmount;
  //           } else {
  //             // Has promo — approximate pump portion from shift discount
  //             const pumpDiscountAmount =
  //               item.vat === 0
  //                 ? Big(pumpDiscount.discountPerLiter)
  //                     .div(1.12)
  //                     .times(item.quantity)
  //                     .round(2)
  //                     .toNumber()
  //                 : Big(pumpDiscount.discountPerLiter).times(item.quantity).round(2).toNumber();
  //             originalTotalAmount = Big(item.originalTotalAmount)
  //               .minus(pumpDiscountAmount)
  //               .round(2)
  //               .toNumber();
  //           }
  //         } else {
  //           originalTotalAmount = item.originalTotalAmount;
  //         }

  //         return { originalTotalAmount };
  //       }),
  //       "originalTotalAmount"
  //     ) || 0
  //   );
  // };

  const computeTotalAmount = (t) => {
    let pumpDiscountVat12Percent = t.quantity * t.pumpDiscountPerItem;

    if (t.vat === 0) {
      pumpDiscountVat12Percent = pumpDiscountVat12Percent / 1.12;
    } else {
      pumpDiscountVat12Percent = 0;
    }

    const pricePerUnit =
      t.type === "fuel"
        ? shift.shift.pricing.find((p) => p.product === nameToSku(t.name))?.pricePerLiter || 0
        : t?.originalPricePerItem || 0;

    // let grossTotalAmount =
    //   t.vat === 0
    //     ? t.quantity * pricePerUnit - pumpDiscountVat12Percent
    //     : t.grossTotalAmount - t.totalPumpDiscount;
    let grossTotalAmount =
      pumpDiscountVat12Percent > 0
        ? t.quantity * pricePerUnit
        : t.originalTotalAmount -
          (t.totalDiscount > 0 && t.discountValue > 0 ? t.totalDiscount : 0);

    // from manual input
    // if (Math.abs(grossTotalAmount - t.originalTotalAmount) <= 0.1) {
    //   // grossTotalAmount =
    //   //   truncate(t.grossTotalAmount, 2) -
    //   //   (t.totalDiscount > 0 && t.discountValue > 0 ? t.totalDiscount : 0);
    //   grossTotalAmount = t.originalTotalAmount;
    // }
    // let totalPumpDiscount = -(t.quantity * t.pumpDiscountPerItem);

    // if (t.vat === 0) {
    //   const pumpDiscountVatAmount = totalPumpDiscount - totalPumpDiscount / 1.12;
    //   totalPumpDiscount = totalPumpDiscount - pumpDiscountVatAmount;
    //   totalPumpDiscount += Math.abs(pumpDiscountVatAmount);
    // }

    return (
      Big(grossTotalAmount || 0)
        // .plus(totalPumpDiscount)
        .round(2)
        .toNumber()
    );
  };
  const computeVatExempt = (items) => {
    return (
      sumBy(
        items.map((t) => {
          // if (isTaxVatExemptItem(t)) {
          //   return { vatExempt: computeTaxVatExemptMagnitude(t) };
          // }
          // const originalTotalAmount = t.grossTotalAmount;
          // const totalPromoDiscount =
          //   t.vat === 0 ? 0 : t.discount && t.pumpDiscountPerItem === 0 ? t.totalDiscount : 0;
          // const vatExempt =
          //   t.vat === 0 && totalPromoDiscount === 0
          //     ? originalTotalAmount - originalTotalAmount / 1.12
          //     : 0;
          // return { vatExempt: Big(vatExempt).round(2).toNumber() }
          return {
            vatExempt: -t.vatExempt12percent,
          };
        }),
        "vatExempt"
      ) || 0
    );
  };

  const computeTotalDiscount = (items) => {
    return (
      sumBy(
        items.map((t) => {
          if (t.totalDiscount > 0 && t.discountValue > 0) {
            return {
              totalDiscount: t.totalDiscount,
            };
          }

          const pumpNumber = Number(String(t.pump).split(" ")[1]);
          const pumpDiscount = shift.shiftDiscounts.find(
            (discount) =>
              discount.product === nameToSku(t.name) && Number(discount.pumpSlot) === pumpNumber
          );
          const isNoDiscountForItem = t?.discount === "" && (t?.pumpDiscountPerItem ?? 0) === 0;
          const effectivePumpDiscount = (() => {
            if ((t.pumpDiscountPerItem ?? 0) > 0) {
              const perLiter = t.vat === 0 ? t.pumpDiscountPerItem / 1.12 : t.pumpDiscountPerItem;
              return Big(perLiter)
                .times(t.quantity || 0)
                .round(2)
                .toNumber();
            }
            if ((t.totalPumpDiscount ?? 0) > 0) {
              return t.totalPumpDiscount;
            }
            if (!isNoDiscountForItem && (pumpDiscount?.discountPerLiter ?? 0) > 0) {
              return t.vat === 0
                ? Big(pumpDiscount.discountPerLiter)
                    .div(1.12)
                    .times(t.quantity || 0)
                    .round(2)
                    .toNumber()
                : Big(pumpDiscount.discountPerLiter)
                    .times(t.quantity || 0)
                    .round(2)
                    .toNumber();
            }
            return 0;
          })();
          let totalPromoDiscount =
            t.vat === 0
              ? 0
              : (t.discount || (pumpDiscount?.discountPerLiter ?? 0) === 0) &&
                t.pumpDiscountPerItem === 0 &&
                t.totalDiscount > 0
              ? Math.max(0, t.totalDiscount - effectivePumpDiscount)
              : 0;

          totalPromoDiscount =
            t.discountValue < 0 ? -Math.abs(totalPromoDiscount) : totalPromoDiscount;
          const adjustedAbsPremium = Math.max(
            0,
            Math.abs(t.totalDiscount ?? 0) - effectivePumpDiscount
          );
          const premiumDiscount = (t.totalDiscount ?? 0) < 0 ? -adjustedAbsPremium : 0;

          return { totalDiscount: totalPromoDiscount + premiumDiscount };
        }),
        "totalDiscount"
      ) || 0
    );
  };

  const formatShiftValue = () => {
    const transactions = [
      ...shift.transactionItem.dieselTransactions,
      ...shift.transactionItem.gas91Transactions,
      ...shift.transactionItem.gas95Transactions,
      ...shift.transactionItem.gas97Transactions,
    ].filter(
      (t) =>
        !t.transaction.adjustmentType && t.pump !== "Pump 02" && t.transaction.status === "sale"
    );

    const isTxnPremium = (t) =>
      Math.abs(t.totalDiscount ?? 0) > 0.005 &&
      (t.pumpDiscountPerItem ?? 0) === 0 &&
      (t.totalPumpDiscount ?? 0) === 0 &&
      (t.discount == null || t.discount === "") &&
      Math.abs((t.grossTotalAmount ?? 0) - (t.netTotalAmount ?? 0)) < 0.01;
    // const totalAmount =
    //   sumBy(transactions, (t) => {
    //     if (isTaxVatExemptItem(t)) {
    //       return computeTaxVatExemptFuelAmount(t, pricePerLiterFor(t));
    //     }
    //     if (isTxnPremium(t)) return txnPremiumAmount(t);
    //     if ((t.pumpDiscountPerItem ?? 0) > 0) {
    //       return t.grossTotalAmount || 0;
    //     }
    //     return (t.totalDiscount || 0) < 0
    //       ? t.originalTotalAmount || 0
    //       : t.grossTotalAmount || 0;
    //   }) || 0;
    const totalAmount =
      sumBy(transactions, (t) => {
        const grossTotalAmount = computeTotalAmount(t);
        return Number(grossTotalAmount);
      }) || 0;
    const totalPremium =
      sumBy(transactions, (t) => (isTxnPremium(t) ? Math.abs(t.totalDiscount || 0) : 0)) || 0;
    const totalPumpDiscount =
      sumBy(
        transactions.map((t) => {
          const pumpNumber = Number(String(t.pump).split(" ")[1]);
          const pumpDiscount = shift.shiftDiscounts.find(
            (discount) =>
              discount.product === nameToSku(t.name) && Number(discount.pumpSlot) === pumpNumber
          );

          let totalPumpDiscount;
          if ((t.pumpDiscountPerItem ?? 0) > 0) {
            const adjusted = t.vat === 0 ? t.pumpDiscountPerItem / 1.12 : t.pumpDiscountPerItem;
            totalPumpDiscount = adjusted * t.quantity;
          } else if ((t.totalPumpDiscount ?? 0) > 0) {
            totalPumpDiscount = t.totalPumpDiscount;
          } else if ((pumpDiscount?.discountPerLiter ?? 0) > 0) {
            totalPumpDiscount =
              t.vat === 0
                ? Big(pumpDiscount.discountPerLiter).div(1.12).times(t.quantity).round(2).toNumber()
                : Big(pumpDiscount.discountPerLiter).times(t.quantity).round(2).toNumber();
          } else {
            totalPumpDiscount = 0;
          }

          return { totalPumpDiscount };
        }),
        "totalPumpDiscount"
      ) || 0;
    const totalVatExempt = computeVatExempt(transactions);
    const totalDiscount = computeTotalDiscount(transactions);

    // const totalAmountFuelSales = sumBy(transactions, "netTotalAmount") || 0;
    const totalAmountFuelSales =
      +totalAmount + totalDiscount + -totalPumpDiscount + -totalVatExempt;

    // const totalAmount = sumBy(transactions, "originalTotalAmount") || 0;

    const totalLitersSold = sumBy(transactions, "quantity") || 0;
    // const totalOriginalAmountFuelSales =
    //   (sumBy(transactions, "grossTotalAmount") || 0) - totalPremiumDiscount;
    // const totalAmountFuelSales = sumBy(transactions, "netTotalAmount") || 0;
    // const totalAmountFuelSales = computeFinalAmount(transactions);
    const totalTotalizerDifference = sumBy(transactions, "totalizerDifference") || 0;
    const totalizerVariance = sumBy(transactions, "totalizerVariance") || 0;
    let allFuelData = {
      totalLitersSold: totalLitersSold,
      totalOriginalAmountFuelSales: totalAmount,
      totalVatExempt: totalVatExempt,
      totalDiscounts: totalDiscount,
      totalAmountFuelSales: totalAmountFuelSales,
      totalTotalizerDifference: totalTotalizerDifference,
      totalizerVariance: totalizerVariance,
      totalPumpDiscount: totalPumpDiscount,
      totalPremium: totalPremium,
    };

    let list = [];
    list.push(allFuelData);
    return list;
  };

  const { table } = useDataTable({
    value: formatShiftValue(),
    filter: { initialState: initialFilterState(), mapper: (val) => val },
    table: {
      key: "shift",
      name: "allFuel",
      mapper: (val) => allFuelProductsMapper({ val, isShiftEndedCompletely }),
      columns: allFuelProductsColumn,
    },
  });

  return (
    <>
      <div className={styles.tableContainer}>
        <DataTableV2
          {...table}
          {...{ name: locale.allFuelProducts }}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsAllFuelProducts;
